module.exports = __webpack_public_path__ + "static/samuel-darcy-lg-bd87ac2790c91cdbe5696bf78c14872f.png";